import script from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=0c5e8414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5e8414"]])

export default __exports__